module.exports = __webpack_public_path__ + "static/nokia-2-99f43e12145e7250f1105815c4bb6d67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/nokia/nokia-2.jpg
// module id = 414
// module chunks = 3627797113349 20562973939449 33019919093843